import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { EYEBROW } from './Band';
export function StatusStrip() {
  return <section id="status" className="w-full scroll-mt-20 border-b border-mist bg-white/50" data-id="element-414" data-mp="yv193i1u0say">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-6 py-14 lg:flex-row lg:items-center lg:justify-between lg:px-10" data-id="element-415" data-mp="ut7cplyo6agl">
        <div data-id="element-416" data-mp="1misiodvzmr8j">
          <p className={`${EYEBROW} text-teal`} data-id="element-417" data-mp="1mh7parletec9">Evidence and status</p>
          <p className="mt-4 max-w-[64ch] text-xl leading-relaxed text-ink" data-id="element-418" data-mp="1igxl9kh6gy01">
            Lentic is early, and specific about it. The mechanic runs end to end
            and every score decomposes to one action; predictive validity is a
            12–18 month question we are not yet claiming.
          </p>
        </div>
        <Link to="/company" className="inline-flex shrink-0 items-center gap-2 rounded-full border border-ink/15 px-6 py-3.5 text-base font-semibold text-ink transition-colors hover:border-ink/40" data-id="element-419" data-mp="266i3g15ibr89">
          What we've proven, and what we haven't
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-420" data-mp="1qsufjssa0wcd" />
        </Link>
      </div>
    </section>;
}